module.exports = __webpack_public_path__ + "static/media/edi1.b19b385d.jpeg";